import React from 'react';
/* eslint-disable */
export function ArrowLeft(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="10" height="15" viewBox="0 0 10 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.59375 0.875C8.09375 0.375 7.3125 0.40625 6.84375 0.90625L1.34375 6.65625C0.875 7.125 0.875 7.90625 1.34375 8.375L6.84375 14.125C7.0625 14.375 7.40625 14.5 7.75 14.5C8.03125 14.5 8.34375 14.4062 8.59375 14.1562C9.09375 13.6875 9.125 12.9062 8.625 12.4062L3.96875 7.53125L8.625 2.625C9.125 2.125 9.09375 1.34375 8.59375 0.875Z"
        fill="currentColor"
      />
    </svg>
  );
}
